export const iconFontAwesomeSpinnersStroopwafel = (
	<i className="fa-solid fa-stroopwafel"></i>
);
